import React from "react";

const HowWork = ({howItWork}) => {

  return (
    <section className="sm:pb-20 pb-[100px] relative">
      <div className="container px-3 lg:px-3 xm:px-2">
        <h2 className="text-textxl text-baseBlack font-medium text-center">
          {howItWork.heading}
        </h2>
        <h3 className="text-heading5 text-baseBlack mt-1 font-medium sm:text-xl text-center">
          {howItWork.subHeading}
        </h3>
        <div className="border-[#C4C4C4] border-[1px] shadow-[0_0_20px_0_rgba(0,0,0,0.1)] p-3 rounded-[20px] mx-auto max-w-[1100px] mt-6">
          <div className="flex flex-wrap items-start">
            {howItWork.steps.map((item, i) => (
              <div
                className="w-[33.33%] relative text-center  p-3 sm:pb-14 px-10 sm:w-full"
                key={i}
              >
                <div>
                  <span className="w-4 h-4 mx-auto text-sm mb-2 leading-[25px] text-white rounded-[50%] text-center block bg-[#086AC9]">
                    {item.id}
                  </span>
                  <p className="text-lg font-medium text-baseBlack">{item.para}</p>
                  {item.title &&
                  <p className="text-base mt-1 text-baseBlack">{item.title}</p>}
                </div>
                {i != 2 && (
                  <div className="absolute top-[50%] sm:text-center sm:top-auto right-[-10px] sm:bottom-1 sm:right-0 mx-auto sm:left-0">
                    <svg
                      className="w-6 h-6 sm:hidden "
                      xmlns="https://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M19.1642 12L12.9571 5.79291L11.5429 7.20712L16.3358 12L11.5429 16.7929L12.9571 18.2071L19.1642 12ZM13.5143 12L7.30722 5.79291L5.89301 7.20712L10.6859 12L5.89301 16.7929L7.30722 18.2071L13.5143 12Z"></path>
                    </svg>
                    <svg
                      className="w-6 h-6 hidden mx-auto sm:block"
                      xmlns="https://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 19.1642L18.2071 12.9571L16.7929 11.5429L12 16.3358L7.20712 11.5429L5.79291 12.9571L12 19.1642ZM12 13.5143L18.2071 7.30722L16.7929 5.89301L12 10.6859L7.20712 5.89301L5.79291 7.30722L12 13.5143Z"></path>
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWork;
